import { render } from "./field_file.vue?vue&type=template&id=adeb484a"
import script from "./field_file.vue?vue&type=script&lang=js"
export * from "./field_file.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployer/asset-portal/releases/20260828153143/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__